import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Magical%20fantasy%20world%20with%20floating%20colorful%20crystals%20and%20glowing%20spirits%2C%20warm%20golden%20and%20amber%20light%20rays%2C%20ethereal%20atmosphere%2C%20ancient%20forest%20with%20luminescent%20flora%2C%20mystical%20portal%20of%20rainbow%20colors%2C%20dreamy%20fantasy%20illustration%20style%2C%20soft%20bokeh%20particles%2C%20enchanting%20and%20whimsical%20mood%2C%20rich%20vibrant%20color%20palette%20with%20warm%20tones%2C%20painterly%20texture%2C%20cinematic%20composition&width=1600&height=900&seq=hero-fantasy-color&orientation=landscape"
        alt="好色精灵探访记 - 奇幻色彩冒险世界"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      <div className="absolute inset-0 bg-gradient-to-r from-primary-500/10 to-accent-500/10"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6">
        <div className="text-center max-w-3xl">
          <h1 className="font-display text-3xl md:text-5xl lg:text-6xl text-white mb-4 leading-tight">
            好色精灵探访记
          </h1>
          <p className="font-heading text-lg md:text-2xl text-white/90 mb-3">
            奇幻色彩冒险
          </p>
          <p className="text-sm md:text-base text-white/70 mb-8 max-w-xl mx-auto leading-relaxed">
            跟随好色精灵探访记中的神奇精灵，穿越缤纷世界，感受色彩的力量与魔法。
            加入好色精灵探访记的奇幻旅程，开启属于你的色彩冒险！
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/chise-jingling"
              className="whitespace-nowrap px-8 py-3 rounded-full bg-primary-500 text-white font-medium hover:bg-primary-600 transition-all duration-300 cursor-pointer text-sm md:text-base shadow-lg shadow-primary-500/25"
            >
              探索冒险篇章
            </Link>
            <Link
              to="/about"
              className="whitespace-nowrap px-8 py-3 rounded-full border-2 border-white/40 text-white font-medium hover:bg-white/15 hover:border-white/60 transition-all duration-300 cursor-pointer text-sm md:text-base"
            >
              了解更多
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <span className="w-8 h-8 flex items-center justify-center text-white/60">
          <i className="ri-arrow-down-s-line text-2xl"></i>
        </span>
      </div>
    </section>
  );
}